export default __webpack_public_path__ + "static/media/warning--horizontal-alignment-right--g1.e52240f3.png";